import { render, staticRenderFns } from "./PayPerItems.vue?vue&type=template&id=71322277"
import script from "./PayPerItems.vue?vue&type=script&lang=js"
export * from "./PayPerItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports